import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'

import Pie from '../atoms/Pie'
import { Flex } from '../atoms/Basics'

const PieContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: -0.5rem;
  margin-left: -0.6rem;
`

const Bar = styled.div`
  border-bottom: ${(props) => `2px solid ${props.theme.colors.gray}`};
  width: 100%;
`
const PieLabel = styled.p`
  color: ${(props) => props.theme.colors.gray};
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: 600;
  line-height: 1.35;
  ${Mq.md} {
    font-size: 12px;
  }
`

const Pies = ({ data }) => {
  const $ = window.WILDLABS_VARS
  return (
    <>
      <Bar />
      <PieContainer>
        <Flex alignItems="center">
          <Pie value={data ? data['% of respondents'] : null} />
          <PieLabel>{$.sw_pie_labels.labelA}</PieLabel>
          <Pie value={data ? data['% are proficient'] : null} />
          <PieLabel>{$.sw_pie_labels.labelB}</PieLabel>
        </Flex>
      </PieContainer>
    </>
  )
}

export default Pies
